/**
 * Profile-update statuses shared by the sidebar tabs, the table status cell and their
 * fixed filter values.
 *
 * The Receipt table renders two models under the same columns. The API's explicit `source`
 * discriminator decides which model a row represents and therefore which modal the eye opens:
 *   - дескрипторний рядок → `Profile details` (одна колонка VALUE);
 *   - profile-update рядок → `Requested profile update` (CURRENT / PROPOSED).
 *
 * Значення збігаються з `ReceiptProfileUpdateStatus` на бекенді і з id сайд-табів
 * у `RequestsPage/index.js` — міняти лише разом з ними.
 */
export const PROFILE_UPDATE_SOURCE = "profile_update"

export const PROFILE_UPDATE_STATUS = Object.freeze({
  PENDING_UPDATE: "pending_update",
  UPDATE_IN_PROGRESS: "update_in_progress",
  UPDATED: "updated",
  UPDATED_FAILED: "updated_failed"
})

export const PROFILE_UPDATE_STATUSES = Object.freeze(Object.values(PROFILE_UPDATE_STATUS))

export const PROFILE_UPDATE_STATUS_LABELS = Object.freeze({
  [PROFILE_UPDATE_STATUS.PENDING_UPDATE]: "Pending update",
  [PROFILE_UPDATE_STATUS.UPDATE_IN_PROGRESS]: "Update in progress",
  [PROFILE_UPDATE_STATUS.UPDATED]: "Updated",
  [PROFILE_UPDATE_STATUS.UPDATED_FAILED]: "Updated failed"
})

/** AntD preset colors; light/dark variants live in `App.less` under `.ant-tag-*`. */
export const PROFILE_UPDATE_STATUS_COLORS = Object.freeze({
  [PROFILE_UPDATE_STATUS.PENDING_UPDATE]: "gold",
  [PROFILE_UPDATE_STATUS.UPDATE_IN_PROGRESS]: "processing",
  [PROFILE_UPDATE_STATUS.UPDATED]: "success",
  [PROFILE_UPDATE_STATUS.UPDATED_FAILED]: "error"
})

/** Dot colors for the status dropdown; keep in sync with the palette in `styles/utils/variables.less`. */
export const PROFILE_UPDATE_STATUS_DOT_COLORS = Object.freeze({
  [PROFILE_UPDATE_STATUS.PENDING_UPDATE]: "#F6B60E",
  [PROFILE_UPDATE_STATUS.UPDATE_IN_PROGRESS]: "#225AEA",
  [PROFILE_UPDATE_STATUS.UPDATED]: "#35BD29",
  [PROFILE_UPDATE_STATUS.UPDATED_FAILED]: "#D71313"
})

export const PROFILE_UPDATE_NEXT_STATUSES = Object.freeze({
  [PROFILE_UPDATE_STATUS.PENDING_UPDATE]: [PROFILE_UPDATE_STATUS.UPDATE_IN_PROGRESS],
  [PROFILE_UPDATE_STATUS.UPDATE_IN_PROGRESS]: [
    PROFILE_UPDATE_STATUS.UPDATED,
    PROFILE_UPDATE_STATUS.UPDATED_FAILED
  ],
  [PROFILE_UPDATE_STATUS.UPDATED]: [],
  [PROFILE_UPDATE_STATUS.UPDATED_FAILED]: []
})

export const isProfileUpdateRow = (row) => row?.source === PROFILE_UPDATE_SOURCE
